import { FC, useContext, useEffect, useMemo } from "react";
import { RefSchemaItem, FormView } from "@data-root/types";
import {
  Inline,
  SchemaItemProps,
  UseRowContext,
  useAppContext,
  useClientContext,
  useField,
  useRow,
} from "@data-root/react";
import { View } from "@data-root/react";
import { Form, InlineFormPresentation } from "../../inline/Form";
import { Button } from "antd";
import { RefInputContext } from ".";
import { Remarks } from "../../remarks";
import { InlineErrorView } from "@/components/InlineErrorView";

export const Guard: FC<SchemaItemProps<RefSchemaItem>> = (props) => {
  const { item } = props;
  const { loaded } = useField(item);

  if (!loaded) return null;

  return <RefInputEmbeddedPresentation {...props} />;
};

export const RefInputEmbeddedPresentation: FC<
  SchemaItemProps<RefSchemaItem>
> = ({ item }) => {
  const { core } = useClientContext();
  const { appSpecifier } = useAppContext();
  const { loaded, value, setValue, remarks } = useField(item);
  const { refTable } = useContext(RefInputContext)!;

  const useRowHook = useRow(core, appSpecifier, item.ref, value as string);
  const { getContext, rowId, error } = useRowHook;

  useEffect(() => {
    if (rowId && rowId !== value) setValue(rowId, rowId);
  }, [rowId, setValue, value]);

  const inlineView = useMemo<FormView>(
    () => ({
      id: `inline:${item.ref}`,
      name: `Inline ${item.ref}`,
      description: `Inline ${item.ref}`,
      type: "Form",
      tableId: item.ref,
      icon: "TableOutlined",
    }),
    [item.ref]
  );

  if (error) return <InlineErrorView error={error} />;

  return (
    <UseRowContext.Provider value={useRowHook}>
      <View style={{ width: "100%" }}>
        <Button onClick={() => useRowHook.commit()}>Save</Button>

        <Inline
          table={refTable}
          view={inlineView}
          options={{
            presentation: InlineFormPresentation.Flat,
          }}
        >
          <Form getContext={getContext} loaded={loaded} />
        </Inline>

        <Remarks texts={remarks} />
      </View>
    </UseRowContext.Provider>
  );
};
